import {
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Select,
  Space,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import uplooadSimple from "../../../../assets/UploadSimple.svg";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import {
  fetchData,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
} from "../../../../features/fetch/fetchSlice";
import { useWatch } from "antd/es/form/Form";
import { saveFile } from "../../../../features/save/saveSlice";
import { formatPath } from "../../../../utils";
import { schStatusData } from "../../../../data";

const { TextArea } = Input;
function Details({ form, fileUrl, setfileUrl, fileCert, setfileCert }) {
  const urlPathway = "api/v2/irrigationPathway/get";
  const urlWard = "ward/fetch_wards";
  const urlConstituency = "constituency/fetch_constituencys";

  const { counties, memberTypes, subCounties, locations, subLocations } =
    useSelector((state) => state.fetch);
  const { activeObjSchemes, dataPathway, dataConstituency, dataWard } =
    useSelector((state) => ({
      activeObjSchemes: state.obj.activeObj["asalSchemes"],
      dataPathway: state.fetch.data[urlPathway] || [],
      dataWard: state.fetch.data[urlWard] || [],
      dataConstituency: state.fetch.data[urlConstituency] || [],
    }));
  const plainOptions = ["Yes", "No"];

  const dispatch = useDispatch();

  async function handleUpload(e) {
    const formObject = new FormData();
    formObject.append("file", e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }
      const res = await dispatch(saveFile(formObject));

      if (res?.payload?.success) {
        await setfileUrl(res.payload?.targetUrl);
        await toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message);
      }
    }
  }

  async function handleOpenFIle() {
    document.getElementById("file").click();
  }
  async function handleCancelFile() {
    await setfileUrl();
  }

  async function handleUploadCert(e) {
    const formObject = new FormData();
    formObject.append("file", e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }
      const res = await dispatch(saveFile(formObject));

      if (res?.payload?.success) {
        await setfileCert(res.payload?.targetUrl);
        await toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message);
      }
    }
  }

  async function handleOpenFIleCert() {
    document.getElementById("file").click();
  }
  async function handleCancelFileCert() {
    await setfileCert();
  }

  const [schCounty, setSchCounty] = useState(activeObjSchemes?.schCounty ?? "");
  const [schConstId, setSchConstId] = useState(
    activeObjSchemes?.schConstId ?? ""
  );
  const [schSubCounty, setSchSubCounty] = useState(
    activeObjSchemes?.schSubCounty ?? ""
  );
  const [schLocation, setSchLocation] = useState(
    activeObjSchemes?.schLocation ?? ""
  );
  const [schTown, setSchTown] = useState(activeObjSchemes?.schTown ?? "");
  const [schWdId, setSchWdId] = useState(activeObjSchemes?.schWdId ?? "");

  const handleSchCountyChange = async (value) => {
    setSchCounty(value);
    setSchConstId("");
    setSchSubCounty("");
    setSchLocation("");
    setSchTown("");
    setSchWdId("");

    form.setFieldsValue({
      schCounty: value,
      schConstId: "",
      schSubCounty: "",
      schLocation: "",
      schTown: "",
      schWdId: "",
    });

    await dispatch(fetchSubCounties({ subCountyId: value }));
    await dispatch(fetchData({ url: urlConstituency, constCounty: value }));
  };

  const handleSchConstituencyChange = async (value) => {
    setSchConstId(value);
    setSchWdId("");

    form.setFieldsValue({
      schConstId: value,
      schWdId: "",
    });

    await dispatch(fetchData({ url: urlWard, wdConst: value }));
  };

  const handleSchSubCountyChange = async (value) => {
    setSchSubCounty(value);
    setSchLocation("");
    setSchTown("");

    form.setFieldsValue({
      schSubCounty: value,
      schLocation: "",
      schTown: "",
    });

    await dispatch(fetchLocation({ locSubId: value }));
  };

  const handleSchLocationChange = async (value) => {
    setSchLocation(value);
    setSchTown("");

    form.setFieldsValue({
      schLocation: value,
      schTown: "",
    });

    await dispatch(fetchSubLocation({ slocLocId: value }));
  };

  const handleSchTownChange = (value) => {
    setSchTown(value);
    form.setFieldsValue({ schTown: value });
  };

  const handleSchWardChange = (value) => {
    setSchWdId(value);
    form.setFieldsValue({ schWdId: value });
  };
  const schemeIwua = useWatch("schHaveIwua", form);
  const schemeLicense = useWatch("schHasIrrLicense", form);

  useEffect(() => {
    if (form.getFieldValue("schHaveIwua") == "No") {
      form.setFieldsValue({ schContactPerson: null });
      form.setFieldsValue({ schContactPhone: null });
      form.setFieldsValue({ schContactPosition: null });
    }
  }, [form, form.getFieldValue("schHaveIwua")]);

  useEffect(() => {
    if (activeObjSchemes?.schId) {
      dispatch(fetchSubCounties({ subCountyId: activeObjSchemes?.schCounty }));
      dispatch(
        fetchData({
          url: urlConstituency,
          constCounty: activeObjSchemes?.schCounty,
        })
      );
      dispatch(
        fetchData({ url: urlWard, wdConst: activeObjSchemes?.schConstId })
      );
      dispatch(fetchLocation({ locSubId: activeObjSchemes?.schSubCounty }));
      dispatch(fetchSubLocation({ slocLocId: activeObjSchemes?.schLocation }));
    }
  }, [activeObjSchemes, form]);
  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
      <Form.Item
        name="schName"
        label={"Scheme Name"}
        rules={[
          {
            required: true,
            message: "Please add scheme name",
          },
        ]}
      >
        <Input className="input" />
      </Form.Item>

      <Form.Item
        name="schCounty"
        label="County"
        rules={[{ required: true, message: "Please select county" }]}
      >
        <Select
          allowClear
          options={counties?.map((c) => ({
            value: c?.countyId,
            label: c?.countyName,
          }))}
          onChange={handleSchCountyChange}
          showSearch
          filterOption={(input, option) =>
            option?.label?.toLowerCase()?.includes(input.toLowerCase())
          }
        />
      </Form.Item>

      {schCounty && (
        <>
          <Form.Item
            name="schConstId"
            label="Constituency"
            rules={[{ required: true, message: "Please select constituency" }]}
          >
            <Select
              allowClear
              options={dataConstituency?.map((c) => ({
                value: c?.constId,
                label: c?.constName,
              }))}
              onChange={handleSchConstituencyChange}
              showSearch
              filterOption={(input, option) =>
                option?.label?.toLowerCase()?.includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item
            name="schSubCounty"
            label="Subcounty"
            rules={[{ required: true, message: "Please select subcounty" }]}
          >
            <Select
              allowClear
              options={subCounties?.map((s) => ({
                value: s?.subId,
                label: s?.subCountyName,
              }))}
              onChange={handleSchSubCountyChange}
              showSearch
              filterOption={(input, option) =>
                option?.label?.toLowerCase()?.includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </>
      )}

      {schSubCounty && (
        <Form.Item
          name="schLocation"
          label="Location"
          rules={[{ required: true, message: "Please select location" }]}
        >
          <Select
            allowClear
            options={locations?.map((l) => ({
              value: l?.locId,
              label: l?.locLocation,
            }))}
            onChange={handleSchLocationChange}
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase()?.includes(input.toLowerCase())
            }
          />
        </Form.Item>
      )}

      {schLocation && (
        <Form.Item
          name="schTown"
          label="Sublocation"
          rules={[{ required: true, message: "Please select sublocation" }]}
        >
          <Select
            allowClear
            options={subLocations?.map((sl) => ({
              value: sl?.slocId,
              label: sl?.slocLocation,
            }))}
            onChange={handleSchTownChange}
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase()?.includes(input.toLowerCase())
            }
          />
        </Form.Item>
      )}

      {schConstId && (
        <Form.Item
          name="schWdId"
          label="Ward"
          rules={[{ required: true, message: "Please select ward" }]}
        >
          <Select
            allowClear
            options={dataWard?.map((w) => ({
              value: w?.id,
              label: w?.wdWard,
            }))}
            onChange={handleSchWardChange}
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase()?.includes(input.toLowerCase())
            }
          />
        </Form.Item>
      )}
      <Form.Item
        name="schLat"
        label={"Latitude (Decimal degrees, WGS84)"}
        rules={[
          {
            required: true,
            message: "Please add latitude",
          },
        ]}
      >
        <InputNumber
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schLong"
        label={"Longitude (Decimal degrees, WGS84)"}
        rules={[
          {
            required: true,
            message: "Please add longitude",
          },
        ]}
      >
        <InputNumber
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>

      <Form.Item
        label={"Have a Registred IWUA ? "}
        name="schHaveIwua"
        rules={[
          {
            required: true,
            message: "Required field",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {schemeIwua === "Yes" ? (
        <>
          <Form.Item
            name="schContactPerson"
            label={"IWUA Contact person"}
            rules={[
              {
                required: true,
                message: "Please add IWUA contact person",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="schContactPhone"
            label={"Phone of Contact Person"}
            rules={[
              {
                required: true,
                message: "Please add phone of contact person",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>
          <Form.Item
            name="schContactPosition"
            className=""
            label={"Position of Contact person"}
            rules={[
              {
                required: true,
                message: "Please select position of contact person",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                memberTypes?.length > 0 &&
                memberTypes?.map((item) => ({
                  value: item?.mbType,
                  label: item?.mbType,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
          <Form.Item
            extra={"File should be in Pdf format"}
            rules={[
              {
                required: schemeIwua === "Yes" ? true : false,
                message: "Upload file .pdf",
              },
            ]}
            name={"schIwuaRegCertFile"}
            label={<span className="">IWUA Registration Certificate</span>}
          >
            {fileCert ? (
              <>
                <div className="text-blueDark w-full flex justify-between items-center h-auto px-3 input truncate">
                  <span className="text-[18px]">{formatPath(fileCert)}</span>

                  <button
                    type="button"
                    onClick={handleCancelFileCert}
                    className="flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M9.5 13H15.5C15.7652 13 16.0196 12.8946 16.2071 12.7071C16.3946 12.5196 16.5 12.2652 16.5 12C16.5 11.7348 16.3946 11.4804 16.2071 11.2929C16.0196 11.1054 15.7652 11 15.5 11H9.5C9.23478 11 8.98043 11.1054 8.79289 11.2929C8.60536 11.4804 8.5 11.7348 8.5 12C8.5 12.2652 8.60536 12.5196 8.79289 12.7071C8.98043 12.8946 9.23478 13 9.5 13ZM21.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V21C2.5 21.2652 2.60536 21.5196 2.79289 21.7071C2.98043 21.8946 3.23478 22 3.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21V3C22.5 2.73478 22.3946 2.48043 22.2071 2.29289C22.0196 2.10536 21.7652 2 21.5 2ZM20.5 20H4.5V4H20.5V20Z"
                        fill="#147CBC"
                      />
                    </svg>
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="input relative" onClick={handleOpenFIleCert}>
                  <input
                    className="!hidden"
                    accept=".pdf"
                    id="file"
                    name="file"
                    onChange={(e) => handleUploadCert(e)}
                    type="file"
                  />
                  <div className="absolute inset-0 flex items-center justify-end pointer-events-none px-3">
                    <img src={uplooadSimple} alt="uploadSimple" />
                  </div>
                </div>
              </>
            )}
          </Form.Item>
        </>
      ) : null}

      <Form.Item
        name="schHasIrrLicense"
        label={"Have irrigation license ? "}
        rules={[
          {
            required: true,
            message: "Required field",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {schemeLicense === "Yes" ? (
        <Form.Item
          extra={"File should be in Pdf format"}
          rules={[
            {
              required: schemeLicense === "Yes" ? true : false,
              message: "Upload file .pdf",
            },
          ]}
          name={"schIrrLicense"}
          label={<span className="">Irrigation License</span>}
        >
          {fileUrl ? (
            <>
              <div className="text-blueDark w-full flex justify-between items-center h-auto px-3 input truncate">
                <span className="text-[18px]">{formatPath(fileUrl)}</span>

                <button
                  type="button"
                  onClick={handleCancelFile}
                  className="flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M9.5 13H15.5C15.7652 13 16.0196 12.8946 16.2071 12.7071C16.3946 12.5196 16.5 12.2652 16.5 12C16.5 11.7348 16.3946 11.4804 16.2071 11.2929C16.0196 11.1054 15.7652 11 15.5 11H9.5C9.23478 11 8.98043 11.1054 8.79289 11.2929C8.60536 11.4804 8.5 11.7348 8.5 12C8.5 12.2652 8.60536 12.5196 8.79289 12.7071C8.98043 12.8946 9.23478 13 9.5 13ZM21.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V21C2.5 21.2652 2.60536 21.5196 2.79289 21.7071C2.98043 21.8946 3.23478 22 3.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21V3C22.5 2.73478 22.3946 2.48043 22.2071 2.29289C22.0196 2.10536 21.7652 2 21.5 2ZM20.5 20H4.5V4H20.5V20Z"
                      fill="#147CBC"
                    />
                  </svg>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="input relative" onClick={handleOpenFIle}>
                <input
                  className="!hidden"
                  accept=".pdf"
                  id="file"
                  name="file"
                  onChange={(e) => handleUpload(e)}
                  type="file"
                />
                <div className="absolute inset-0 flex items-center justify-end pointer-events-none px-3">
                  <img src={uplooadSimple} alt="uploadSimple" />
                </div>
              </div>
            </>
          )}
        </Form.Item>
      ) : null}
      <Form.Item
        label={"Pathways"}
        name="schPathwayId"
        rules={[
          {
            required: true,
            message: "PLease add pathways",
          },
        ]}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              <Space style={{ padding: "8px 8px 4px" }}>
                <span className="select-info mt-1">
                  Choose one or more of the following pathways
                </span>
              </Space>
              <Divider style={{ margin: "8px 0" }} />
              {menu}
            </>
          )}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children?.toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
        >
          {dataPathway?.length > 0 &&
            dataPathway?.map((item) => (
              <Select.Option
                key={item?.irrigationPathwayId}
                value={item?.irrigationPathwayId}
              >
                {item?.irrigationPathwayName}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="schStatus"
        className=""
        label={"Status"}
        rules={[
          {
            required: true,
            message: "Please select scheme status",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            schStatusData?.length > 0 &&
            schStatusData?.map((item) => ({
              value: item?.value,
              label: item?.label,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      <Form.Item
        extra={"Maximum 500 words"}
        name="schDesc"
        label={"Scheme Description"}
        rules={[
          {
            required: true,
            message: "Please add scheme description",
          },
        ]}
        getValueFromEvent={(e) => {
          const input = e?.target?.value || "";
          const words = input?.trim()?.split(/\s+/);
          if (words?.length > 500) {
            toast?.error("Maximum 500 words allowed.");
            return words?.slice(0, 500)?.join(" ");
          }
          return input;
        }}
      >
        <TextArea placeholder="Description..." rows={5} className="text_area" />
      </Form.Item>
    </div>
  );
}

export default Details;
